module.exports = __webpack_public_path__ + "static/img/banner.fa134f1f.jpeg";